var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        design: "v3",
        large: "",
        "show-footer": false,
        "show-title": false,
        "class-name": "ad-detail-modal",
      },
      on: { cancel: _vm.onClose },
    },
    [
      _vm.ad
        ? _c("div", { staticClass: "ad-detail" }, [
            _c("div", { staticClass: "ad-header" }, [
              _c("div", { staticClass: "ad-header-left" }, [
                _c("span", {
                  staticClass: "status-dot",
                  class: String(
                    _vm.ad.effective_status || _vm.ad.status || ""
                  ).toLowerCase(),
                  attrs: {
                    title: _vm.ad.effective_status || _vm.ad.status || "",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "ad-title-block" }, [
                  _c("div", { staticClass: "ad-title" }, [
                    _vm._v(_vm._s(_vm.ad.name || _vm.ad.id)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ad-id" }, [
                    _vm._v("ID: " + _vm._s(_vm.ad.id)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.metaUrl
                ? _c(
                    "a",
                    {
                      staticClass: "open-meta",
                      attrs: {
                        href: _vm.metaUrl,
                        target: "_blank",
                        rel: "noopener",
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("open_in_new"),
                      ]),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("metaInsights.adDetail.openInMeta")) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ad-meta-row" }, [
              _c("div", { staticClass: "meta-item" }, [
                _c("div", { staticClass: "meta-label" }, [
                  _vm._v(_vm._s(_vm.$t("metaInsights.adDetail.status"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "meta-value" }, [
                  _c(
                    "span",
                    {
                      staticClass: "status-badge",
                      class: String(
                        _vm.ad.effective_status || ""
                      ).toLowerCase(),
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.ad.effective_status || _vm.ad.status || "-"
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-item" }, [
                _c("div", { staticClass: "meta-label" }, [
                  _vm._v(_vm._s(_vm.$t("metaInsights.adDetail.created"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "meta-value" }, [
                  _vm._v(_vm._s(_vm.formatDate(_vm.ad.created_time))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-item" }, [
                _c("div", { staticClass: "meta-label" }, [
                  _vm._v(_vm._s(_vm.$t("metaInsights.adDetail.updated"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "meta-value" }, [
                  _vm._v(_vm._s(_vm.formatDate(_vm.ad.updated_time))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ad-body" }, [
              _vm.creative
                ? _c("div", { staticClass: "section" }, [
                    _c("div", { staticClass: "section-title" }, [
                      _vm._v(_vm._s(_vm.$t("metaInsights.adDetail.creative"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "creative-card" }, [
                      _c("div", { staticClass: "creative-media" }, [
                        _vm.creativeImage
                          ? _c("img", {
                              staticClass: "creative-img",
                              attrs: {
                                src: _vm.creativeImage,
                                alt: _vm.creative.name || _vm.ad.name,
                              },
                            })
                          : _c("div", { staticClass: "creative-placeholder" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("image"),
                              ]),
                            ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "creative-body" }, [
                        _vm.creativeTitle
                          ? _c("div", { staticClass: "creative-title" }, [
                              _vm._v(_vm._s(_vm.creativeTitle)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.creativeMessage
                          ? _c("div", { staticClass: "creative-message" }, [
                              _vm._v(_vm._s(_vm.creativeMessage)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.creativeDescription
                          ? _c("div", { staticClass: "creative-desc" }, [
                              _vm._v(_vm._s(_vm.creativeDescription)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.creativeLink
                          ? _c(
                              "a",
                              {
                                staticClass: "creative-link",
                                attrs: {
                                  href: _vm.creativeLink,
                                  target: "_blank",
                                  rel: "noopener",
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("link"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(_vm.creativeLink))]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.callToAction
                          ? _c("div", { staticClass: "creative-cta" }, [
                              _c("span", { staticClass: "cta-badge" }, [
                                _vm._v(_vm._s(_vm.callToAction)),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(_vm.$t("metaInsights.adDetail.performance"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "kpi-grid" },
                  _vm._l(_vm.kpiList, function (kpi) {
                    return _c(
                      "div",
                      { key: kpi.key, staticClass: "kpi-card" },
                      [
                        _c("div", { staticClass: "kpi-label" }, [
                          _vm._v(_vm._s(kpi.label)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "kpi-value" }, [
                          _vm._v(_vm._s(kpi.value)),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _vm.actionRows.length > 0
                ? _c("div", { staticClass: "section" }, [
                    _c("div", { staticClass: "section-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("metaInsights.adDetail.actionBreakdown"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "action-list" },
                      _vm._l(_vm.actionRows, function (row) {
                        return _c(
                          "div",
                          { key: row.type, staticClass: "action-item" },
                          [
                            _c("div", { staticClass: "action-info" }, [
                              _c("div", { staticClass: "action-icon" }, [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v(_vm._s(row.icon)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "action-label" }, [
                                _vm._v(_vm._s(row.label)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "action-numbers" }, [
                              _c("div", { staticClass: "action-count" }, [
                                _vm._v(_vm._s(_vm.formatNumber(row.value))),
                              ]),
                              _vm._v(" "),
                              row.cost != null
                                ? _c("div", { staticClass: "action-cost" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.formatCurrency(row.cost)) +
                                        " / " +
                                        _vm._s(
                                          _vm.$t("metaInsights.action.perUnit")
                                        ) +
                                        "\n                            "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.hasInsights
                ? _c("div", { staticClass: "empty-insights" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("metaInsights.adDetail.noInsights")) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }